import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "unit",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "unit-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
